import { render } from "./KeyenceHTHardKeySerialNumberButton.vue?vue&type=template&id=15f590c6"
import script from "./KeyenceHTHardKeySerialNumberButton.vue?vue&type=script&lang=ts"
export * from "./KeyenceHTHardKeySerialNumberButton.vue?vue&type=script&lang=ts"
script.render = render

export default script